import { render, staticRenderFns } from "./bioNews.vue?vue&type=template&id=6163388e&"
import script from "./bioNews.vue?vue&type=script&lang=js&"
export * from "./bioNews.vue?vue&type=script&lang=js&"
import style0 from "./bioNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports